import { fetchApi } from "@lib/api-fetcher";
import { API_ROUTES } from "@utils/constants";
import { reportError } from "@utils/errorReporting";

import validateDefaultAddressResponse from "../models/defaultAddress";
import type { TDefaultAddress } from "../types";
import mapDefaultAddressResponse from "../utils/mapDefaultAddressResponse";

const loadDefaultAddress = async (): Promise<TDefaultAddress | null> => {
  try {
    const response = await fetchApi({
      url: API_ROUTES.DEFAULT_ADDRESS,
    });
    if (!response.data) {
      return null;
    }
    const addressResponse = validateDefaultAddressResponse(response.data);
    return mapDefaultAddressResponse(addressResponse);
  } catch (err) {
    reportError(err, { module: "order" });
    return null;
  }
};
export default loadDefaultAddress;
